<template>
    <div>
        <section>
            <b-overlay>
                <b-card-code>
                    <b-card no-body class="mx-2">
                        <b-row xl="12" class="d-flex justify-content-center">
                            <b-col class="mr-4 my-1 mt-2">
                                <template>
                                    <div>
                                        <v-select label="title" v-model="selected" :options="projectOptions" :reduce="projectOptions => projectOptions.value" />
                                    </div>
                                </template>
                            </b-col>
                            <b-col class="mx-4">
                                <template>
                                    <div>
                                        <div class="mx-6 d-flex  justify-content-center px-20 mt-2">
                                            <div class="d-flex align-items-center">
                                                <b-img v-bind="mainProps" blank-color="#EA5455"
                                                    alt="Named color image (red)" />
                                                <span class="p-1">Error</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <b-img v-bind="mainProps" blank-color="#FF9F43"
                                                    alt="Named color image (red)" />
                                                <span class="p-1">Limit</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <b-img v-bind="mainProps" blank-color="#7367F0"
                                                    alt="Named color image (red)" />
                                                <span class="p-1">Handle</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <b-img v-bind="mainProps" blank-color="#1E1E1E"
                                                    alt="Named color image (red)" />
                                                <span class="p-1">Offline</span>
                                            </div>
                                        </div>
                                        <hr class="hr">
                                    </div>
                                </template>
                            </b-col>
                            <b-col>
                                <template>
                                    <div class="d-flex setting justify-content-end mt-2">
                                        <b-button class="setting2 float-right" variant="primary">
                                            <b-avatar size="30" class="bg-white  ">
                                                <b-img v-bind="setting" src="../../../assets/images/icons/settingssu.svg" />
                                            </b-avatar>
                                        </b-button>
                                    </div>
                                </template>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card-code>
                <b-card-code class="d-flex shadow  shadow-lg shadow px-3 mb-5 rounded">
                    <div class="d-flex ">
                        <!-- Card -->
                        <b-link :to="{ path: '/monitoring/detailproject' }">
                        <b-card style="max-width: 286px; max-height: 210px;"
                            class="cardsize mx-2 px-2 border border-danger d-flex justify-content-center mt-2 ">
                            <b-row>
                                <b-col lg="4">
                                    <b-avatar size="60" class=" bg-black">
                                        <b-img class="" rounded="circle" v-bind="logo"
                                            src="https://chronosuniversal.com/wp-content/uploads/2021/02/LOGO-CHRONOS-UNIVERSAL.png" />
                                    </b-avatar>
                                </b-col>
                                <b-col lg="8" class="font-monitor my-1">
                                    <h4 class="text-black  mb-1 text font-monitor ">
                                        Suhu
                                    </h4>
                                    <h6 class="text-black  font-monitor-isi">
                                        PT Gudang Garam
                                    </h6>
                                </b-col>
                            </b-row>
                            <b-card-body class=" " style="max-width: 289px; max-height: 179px;">
                                <b-row class="  flex-horizontal  ">
                                    <b-col class=" mb-1 text-center bg-danger" md="5">
                                        <h4 class="text-white font-monitor">
                                            0
                                        </h4>
                                        <span class=" text-white font-monitor-isi">Error</span>
                                    </b-col>
                                    <b-col class="" lg="2">
                                        <div style="border-left:1px solid #000000;height:30px" />
                                    </b-col>
                                    <b-col class="mb-1 text-center border border-dark" md="5">
                                        <h4 class="text-black font-monitor">
                                            0
                                        </h4>
                                        <span class="font-monitor-isi">Limit</span>
                                    </b-col>
                                </b-row>
                                <b-row class="  flex-horizontal  ">
                                    <b-col class="mb-1  text-center border border-dark" md="5">
                                        <h4 class="text-black font-monitor">
                                            0
                                        </h4>
                                        <span class="font-monitor-isi">Handle</span>
                                    </b-col>
                                    <b-col class="mb-1" lg="2">
                                        <div style="border-left:1px solid #000000;height:30px" />
                                    </b-col>
                                    <b-col class="mb-1  text-center border border-dark" md="5">
                                        <h4 class="text-black font-monitor">
                                            0
                                        </h4>
                                        <span class="font-monitor-isi">Offline</span>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-link>
                        <!-- Card -->
                    </div>
                </b-card-code>
            </b-overlay>
        </section>
    </div>
</template>
  
<script>
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCol,
    BOverlay,
    BCard,
    BRow,
    // BIcon,
    // BTable,
    BImg,
    // BBadge,
    // BMediaBody,
    BAvatar,
    // BCardText,
    // BMediaAside,
    // BMedia,
    // BFormGroup,
    BFormSelect,
    // BPagination,
    // BInputGroup,
    // BFormInput,
    // BInputGroupAppend,
    BButton,
    // BModal,
    // BFormTextarea,
    BCardBody,
    BLink,
    //   BDropdown,
    //   BDropdownItem,
} from 'bootstrap-vue'

export default {
    components: {
        BCardCode,
        BCol,
        BOverlay,
        // BIcon,
        BCard,
        // BFormTextarea,
        BRow,
        // BTable,
        BImg,
        // BBadge,
        // BMediaBody,
        BAvatar,
        // BCardText,
        // BMediaAside,
        // BMedia,
        // BFormGroup,
        BFormSelect,
        // BPagination,
        // BInputGroup,
        // BFormInput,
        // BInputGroupAppend,
        BButton,
        // BModal,
        BCardBody,
        BLink,
        vSelect,
        // BDropdown,
        // BDropdownItem,
    },
    data() {
        return {
            mainProps: {
                center: true,
                blank: true,
                width: 25,
                height: 25,
                class: 'm1',
            },
            logo: {
                width: 60,
                height: 60,
            },
            setting: {
                width: 25,
                height: 25,
            },
            setting2: {
                width: 35,
                height: 35,
            },
            projectOptions: [
            { title: 'Pt Chronos Universal', value: 'Ch' },
            { title: 'Millenia Data Scape', value: 'Mds' },
            { title: 'Tekno Pro', value: 'Tnp' },
            { title: 'KIIC', value: 'Kiic' },
            { title: 'Elitech', value: 'elt' },
            ],
        }
    },
}
</script>
  
<style>
.flex-horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.border-left {
    border-left: 1px solid #000000;
    height: 30px;
}

.hr {
    border-top: 2px solid #ebe9f1;
    margin: 0 !important;
}

.setting {
    padding-right: 2px;
    padding-left: 2px;
    padding-top: 2px;
    padding-bottom: 2px;
    margin-right: 10px;
}

.cardsize {
    width: 750px !important;
}

#box {
    padding: 0 !important;
}

.nomp {
    margin: 0 !important;
    padding: 0 !important;
}

.card-body {
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.font-monitor {
    font-size: 14px !important;
    margin-bottom: 0 !important;
}

.font-monitor-isi {
    font-size: 12px !important;
}
</style>
  